import { DOSSIERS_QUERY_KEY, useUpdateDossierPropertyQueriesData } from "@/entities/dossier";
import { LogboekItem } from "@/entities/logboek/domain.ts";
import { queryClient, useApiClient } from "@/infrastructure/rest";
import { LogboekEvent, useRealtimeTopic } from "@/infrastructure/rsocket";
import { LogboekEntryDto } from "@/shared/types";
import { useQuery } from "@tanstack/react-query";
import { LOGBOEK_QUERY_KEY } from "./constants";

function getDossierLogboekQuery(id: string, apiClient: ReturnType<typeof useApiClient>) {
    return {
        queryKey: [DOSSIERS_QUERY_KEY, id, LOGBOEK_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<LogboekEntryDto[]>(`/dossiers/${id}/logboek`);
            return data?.map((dto) => LogboekItem.fromDto(dto)).sort(LogboekItem.sort) ?? [];
        },
    };
}

export function usePrefetchDossierDossierLogboekQuery(id: string) {
    const apiClient = useApiClient();
    const query = getDossierLogboekQuery(id, apiClient);

    return () => queryClient.prefetchQuery({ ...query, staleTime: 60_000 });
}

export function useGetDossierLogboekById(id: string) {
    const apiClient = useApiClient();
    const query = getDossierLogboekQuery(id, apiClient);
    return useQuery(query);
}

export function useRealtimeLogboek() {
    const { handleEvent } = useUpdateDossierPropertyQueriesData("logboek");

    useRealtimeTopic<LogboekEvent>("logboek", {
        onMessage: (message) => {
            const { logEntry, dossierId, reason } = message;
            handleEvent(dossierId, logEntry.id, reason, LogboekItem.fromDto(logEntry), LogboekItem.sort);
        },
    });
}
